module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter1"
  }, [_c('b', [_vm._v("SEARCHING FOR SELF-RELIANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("On poverty’s stage")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Inconsolable rage")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Hurting loved ones most")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Insecurity lurks")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Nothing works")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Life’s an empty boast.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Children see")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("The real me")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Lost in hopeless sorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Creator knows")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Poverty’s blows")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("A time of no tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("All defiance")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("No self-reliance")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("A psyche on parole")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Needs action")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Not subtraction")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("To make the spirit whole.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14fa4bc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1b.vue
// module id = 102
// module chunks = 0